module.exports = __webpack_public_path__ + "static/media/negative.b3fc1319.mp3";